import Vue from 'vue';
import handlerFactory from './window-event-handler'

Vue.directive('resize', handlerFactory('resize'));
